import React from 'react';

const ModuleProductDetailSharing = () => (
    <div className="ps-product__sharing" style={{display: 'flex', alignItems: 'center', gap: '0px'}}>
        <a className="facebook" href="https://www.facebook.com/profile.php?id=61591536856123/" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/facebook.png" alt="Facebook" width="28" style={{display: 'block'}} />
        </a>
        <a className="twitter" href="https://x.com/rawentocom/" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/twitter.png" alt="Twitter" width="28" style={{display: 'block'}} />
        </a>
        <a className="google" href="https://www.youtube.com/@rawentocom/" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/youtube.png" alt="YouTube" width="28" style={{display: 'block'}} />
        </a>
        <a className="linkedin" href="https://linkedin.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/linkedin.png" alt="LinkedIn" width="28" style={{display: 'block'}} />
        </a>
        <a className="instagram" href="https://www.instagram.com/rawentocom/" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/instagram.png" alt="Instagram" width="28" style={{display: 'block'}} />
        </a>
        <a className="tiktok" href="https://www.tiktok.com/@rawentocom" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/tiktok.png" alt="TikTok" width="28" style={{display: 'block'}} />
        </a>
        <a className="pinterest" href="https://www.pinterest.de/rawentocom" target="_blank" rel="noopener noreferrer">
            <img src="https://rawento.com/static/services/pinterest.png" alt="Pinterest" width="28" style={{display: 'block'}} />
        </a>
    </div>
);

export default ModuleProductDetailSharing;